import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconPolygonS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3 11H2C2 9.42503 2.36317 7.87502 3.04409 6.53698L3.95862 6.94543C3.34021 8.14126 3 9.54919 3 11Z"
        fill="currentcolor"
      />
      <path
        d="M11 2V3C9.51865 3 8.11914 3.32629 6.93369 3.94363L6.51902 3.03207C7.85208 2.34865 9.39797 2 11 2Z"
        fill="currentcolor"
      />
      <path
        d="M4 13.5C4 14.3284 3.32843 15 2.5 15C1.67157 15 1 14.3284 1 13.5C1 12.6716 1.67157 12 2.5 12C3.32843 12 4 12.6716 4 13.5Z"
        fill="var(--color-typo-primary)"
      />
      <path
        d="M15 2.5C15 3.32843 14.3284 4 13.5 4C12.6716 4 12 3.32843 12 2.5C12 1.67157 12.6716 1 13.5 1C14.3284 1 15 1.67157 15 2.5Z"
        fill="var(--color-typo-primary)"
      />
      <path
        d="M6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}
export const IconPolygon = createIcon({
  l: IconPolygonS,
  m: IconPolygonS,
  s: IconPolygonS,
  xs: IconPolygonS,
  name: 'IconPolygon',
})
